var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item-group',{attrs:{"active-class":"primary"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('BlogDrops')]}}])})],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('Facebook')]}}])})],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('ViolentNoise')]}}])})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }